<script>
    import {projectDetail} from '../../store'
</script>
<div class="wrong-raised-modal">
    <h2>Flagged Raise</h2>
    {#if $projectDetail.admin_msg}
        {#if $projectDetail.admin_msg.length == 0}
            <p>This project has been flagged by polinate team</p>
        {:else}
            {$projectDetail.admin_msg}
        {/if}
    {:else}
        <p>This project has been flagged by polinate team</p>    
    {/if}
    
</div>